function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import LinearProgress from "@material-ui/core/LinearProgress";
import { isEmpty } from "lodash";
import React, { Component } from "react";
export var LoadProgressBar = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(LoadProgressBar, Component);
    var _super = _create_super(LoadProgressBar);
    function LoadProgressBar(props) {
        _class_call_check(this, LoadProgressBar);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            completed: 0
        };
        _this.timer = null;
        _this.progress = _this.progress.bind(_assert_this_initialized(_this));
        _this.checkForEmptyItems = _this.checkForEmptyItems.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(LoadProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.checkForEmptyItems(this.props.items)) {
                    this.timer = setInterval(this.progress, 100);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this.timer);
            }
        },
        {
            /**
     *  Checks if some of the items in an array is empty
     *  @param items {Array}
     *  returns {Boolean}
     */ key: "checkForEmptyItems",
            value: function checkForEmptyItems(items) {
                return items.some(function(item) {
                    return isEmpty(item);
                });
            }
        },
        {
            /**
     * While some of the items passed to the component
     * fills the progress bar with random rate.
     */ key: "progress",
            value: function progress() {
                var completed = this.state.completed;
                var diff = Math.random() * 10;
                if (this.checkForEmptyItems(this.props.items)) {
                    this.setState({
                        completed: Math.min(completed + diff, 100)
                    });
                } else {
                    this.setState({
                        completed: 100
                    });
                    clearInterval(this.timer);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _jsx(LinearProgress, {
                    variant: "determinate",
                    className: "loading-progress-bar".concat(this.checkForEmptyItems(this.props.items) ? " active" : " completed"),
                    value: this.state.completed
                });
            }
        }
    ]);
    return LoadProgressBar;
}(Component);
export default LoadProgressBar;
